import React from "react";
import { FormattedMessage } from "react-intl";
import {
  Root,
  Title,
  Row,
  Label,
  Value,
  Divider,
  ErrorMessage,
  UserCard,
  UserCardAvatar,
  UserCardBody,
  UserCardPoints,
  ButtonContainer,
} from "./OrderSummary.style";
import { Typography } from "../../ui/Typography/Typography";
import { Button } from "../../ui/Button/Button";
import { getUserAvatar } from "../../utils/user";
import defaultAvatarSrc from "../../assets/images/avatar.png";

export const OrderSummary = ({
  subtotalPts = 0,
  shipping = 0,
  totalPts = 0,
  availablePoints = 0,
  user = null,
  onCheckout = null,
  disabled = false,
}) => {
  const hasEnoughPoints = availablePoints >= totalPts;

  return (
    <Root>
      <Title>
        <FormattedMessage defaultMessage="Order summary" />
      </Title>

      <Row>
        <Label>
          <FormattedMessage defaultMessage="Subtotal" />
        </Label>
        <Value>{subtotalPts.toLocaleString("en-US")} PTS</Value>
      </Row>

      <Row>
        <Label>
          <FormattedMessage defaultMessage="Shipping" />
        </Label>
        <Value>${shipping.toFixed(2)}</Value>
      </Row>

      <Divider />

      <Row $isTotal>
        <Label $isTotal>
          <FormattedMessage defaultMessage="Total" />
        </Label>
        <Value $isTotal>
          {totalPts.toLocaleString("en-US")} <FormattedMessage defaultMessage="PTS" />
        </Value>
      </Row>

      {!hasEnoughPoints && (
        <ErrorMessage>
          <FormattedMessage defaultMessage="You don't have enough points for this order" />
        </ErrorMessage>
      )}

      <UserCard>
        <UserCardBody>
          <UserCardAvatar>
            <img src={getUserAvatar(user) || defaultAvatarSrc} alt="User avatar" />
          </UserCardAvatar>
          <Typography type="text-small" color="#8f95a5">
            <FormattedMessage defaultMessage="Available Points" />
          </Typography>
        </UserCardBody>
        <UserCardPoints>
          {availablePoints.toLocaleString("en-US")}{" "}
          <FormattedMessage defaultMessage="PTS" />
        </UserCardPoints>
      </UserCard>

      <ButtonContainer>
        <Button
          variant="auth"
          arrow={false}
          disabled={disabled || !hasEnoughPoints}
          onClick={onCheckout}
        >
          <FormattedMessage defaultMessage="Go to checkout" />
        </Button>
      </ButtonContainer>
    </Root>
  );
};

